// extracted by mini-css-extract-plugin
export default {"description":"style_description__+0btt","fade-in":"style_fade-in__iLc0s","top":"style_top__uSkmE","image":"style_image__Z5flP"};